import * as $ from 'jquery';
import * as rebindTab from "./rebindTab";
import * as SearchHistory from './searchHistory';

export function initialize(): void {
    setInitialTabState();
    hookuparrows();
    wireEvents();
}

function hookuparrows() {
    try {
        if (!!$(".tabs-container") && !!$("#scrollcontent")) {
            const container = document.querySelector('.tabs-container') as HTMLElement;
            const content = document.getElementById('scrollcontent') as HTMLElement;
            const leftArrow = document.getElementById('left-arrow') as HTMLElement;
            const rightArrow = document.getElementById('right-arrow') as HTMLElement;

            function updateArrows() {
                const isOverflowing = content.scrollWidth > container.clientWidth;

                if (isOverflowing) {
                    if (content.scrollLeft > 0) {
                        leftArrow.style.display = 'block';
                    } else {
                        leftArrow.style.display = 'none';
                    }

                    if (content.scrollLeft < (content.scrollWidth - container.clientWidth)) {
                        rightArrow.style.display = 'block';
                    } else {
                        rightArrow.style.display = 'none';
                    }
                } else {
                    leftArrow.style.display = 'none';
                    rightArrow.style.display = 'none';
                }
            }

            function scrollContainer(direction: 'left' | 'right') {
                const scrollAmount = direction === 'left' ? -content.clientWidth : content.clientWidth;
                content.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }

            content.addEventListener('scroll', updateArrows);
            window.addEventListener('resize', updateArrows);

            leftArrow.addEventListener('click', (e) => {
                e.preventDefault();
                scrollContainer('left')
            });

            rightArrow.addEventListener('click', (e) => {
                e.preventDefault();
                scrollContainer('right')
            });

            // Initial check
            updateArrows();
        }
    } catch (e) {
        console.warn("arrow issues:", e);
    }
}

function setInitialTabState() {
    hideTabContent();
    $('.js-tabcontent.js-active').show();
    setTabName($('.tabs__link--active'));
}

function wireEvents() {
    $('.js-show-tabs').on('click', showTabs);
    $('.js-hide-tabs').on('click', hideTabs);
    $('.js-tab').on('click', switchTab);
    $('.js-document-tab').on('click', switchSubjectTab);
    $('.js-course-tab').on('click', switchSubjectTab);
}

function hideTabContent() {
    $('.js-tabcontent').hide();
}

function setTabName($element: JQuery<HTMLElement>) {
    $('#mobile-tab-selector').text($element.text());
}

function showTabs() {
    $('.tabs-container').addClass('tabs-container--open');
}

function hideTabs() {
    $('.tabs-container').removeClass('tabs-container--open');
}

function sendUserHasClickedOnTab() {
    const Http = new XMLHttpRequest();
    const url = "/api/badgification/1.0/addbadge/" + 8;
    Http.open("GET", url);
    Http.send();
}

function switchTab(e) {
    e.preventDefault();

    sendUserHasClickedOnTab();

    const $this = $(this);
    const name = $this.data('name');
    const target = $this.data('target');
    const $target = $(target);

    $('.tabs__link--active').removeClass('tabs__link--active');
    $this.addClass('tabs__link--active');

    const $searchHitsText = $this.html(); // <-- hämtar text från span
    const $searchHitsCountText = $this.find('span').text(); // <-- hämtar text från span

    $('.searchHits .hits').text($searchHitsCountText);
    $('#mobile-toolbar__open').html($searchHitsText);

    const $searchHitsTexten = $this.text().trim();

    $('#mobile-toolbar__open').toggleClass('button-fullwidth', $searchHitsTexten.startsWith('Alla') || $searchHitsCountText == '0');

    hideTabContent();
    $target.addClass('js-active');
    $target.show();

    $("input[name='tab']").val(name);

    const $form = $("#searchform");
    $form.find("input[name='page']").val("1");
    $form.find("input[name='tab']").val(name);

    $(".content.search-results").addClass("loading");

    $.post($form.data("partialurl"), $form.serialize(), (response) => {

        const $response = $(`<div>${response}</div>`);
        const $responseTab = $response.find(".js-tabcontent-main:first");

        const pageTabId = $form.find("input[name='tab']").val();
        const $pageTab = $("#tab-" + pageTabId);

        setTabName($this);

        rebindTab.rebind($responseTab);
        $pageTab.replaceWith($responseTab);

        const $activeTabLink = $(".tabs__link--active:first");
        const $responseTabText = $response.find(".tabs__link--active:first").html();
        $activeTabLink.html($responseTabText);

        const $searchHitsText = $response.find(".tabs__link--active:first span").text();
        $('#searchHits').text($searchHitsText);
        $('#mobile-toolbar__open span').text($searchHitsText);

        $('#mobile-toolbar__open')
            .toggleClass('button-fullwidth', $searchHitsText === '0');

        const currentUrl = new URL(window.location.href);

        document.querySelectorAll<HTMLAnchorElement>(".pagination-container__pages a")
            .forEach(link => {
                const linkUrl = new URL(link.href);

                currentUrl.searchParams.forEach((value, key) => {
                    if (key !== "page" && key !== "tab") {
                        linkUrl.searchParams.set(key, value);
                    }
                });

                linkUrl.searchParams.set("tab", pageTabId);
                link.href = linkUrl.toString();
            });

        $(".content.search-results").removeClass("loading");

        SearchHistory.update();
    });
    
}

function switchSubjectTab(e) {
    e.preventDefault();

    const $this = $(this);
    if ($this.hasClass("tabs__link--active")) {
        return;
    }
    else {
        const name = $this.data('name');
        const target = $this.data('target');
        const $target = $(target);
        var input: HTMLInputElement = document.querySelector('#document-search-field');
        $('.js-active').removeClass("js-active");
        $('.tabs__link--active').removeClass('tabs__link--active');
        $('.tabs__item--active').removeClass('tabs__item--active');
        input.placeholder = input.placeholder.includes("ett dokument") ? input.placeholder.replace("ett dokument", "en kurs") : input.placeholder.replace("en kurs", "ett dokument");
        $this.addClass('tabs__link--active');
        $this.parent(".tabs__item").addClass('tabs__item--active');
        hideTabContent();
        $target.addClass('js-active');
        $target.show();
        $("input[name='tab']").val(name);

        $(".documents").addClass("loading");
        $.get("Filter", { query: input.value, page: "1", isCourse: $("#tab-Kurser").hasClass("js-active") }, function (data) {
            const newParams = new URLSearchParams({ page: "1", isCourse: $("#tab-Kurser").hasClass("js-active").toString(), query: input.value });
            window.history.replaceState({}, "", "?" + newParams.toString());
            $("#result-partial").replaceWith(data);
            $(".documents").removeClass("loading");
        });
        
    }
}
